<template>
    <div class="orders">
        <claim-line-importer :active.sync="claimLinesImporter.active"></claim-line-importer>
        <div class="columns is-gapless is-mobile" style="height: 100%">
            <div id="split-1" class="column is-6" style="margin: 0px; padding: 0px; overflow-y: hidden">
                <orders-table
                    v-show="mode === 'list'"
                    :fetch-params="fetchParams"
                    :selected.sync="selectedOrder"
                    :checked.sync="checkedOrders"
                    :source="orderSource"
                    :per-page="perPage"
                    @fetch="onTableFetch"
                    ref="ordersTable"
                    :filters="filters"
                >
                    <template #headerButtons>
                        <b-button v-if="canBulkComplete" @click="() => (claimLinesImporter.active = true)">
                            IMPORT CLAIM LINES
                        </b-button>
                        <div v-if="isFilterStatus('BLAP')" class="mr-05">
                            <base-select :service="$options.orderService" fetch-func="listBillingCodes"
                                value-key="billing_code" label-key="billing_code" :disabled="checkedOrderIds.length == 0">
                                <template #control="{ value }">
                                    <p class="control">
                                        <b-button :loading="billingCodeUpdating" :disabled="checkedOrderIds.length == 0"
                                            @click="updateBillingCode(value)">
                                            UPDATE
                                        </b-button>
                                    </p>
                                </template>
                            </base-select>
                        </div>
                        <b-button v-if="isFilterStatus('PHYSICALLY_COMPLETED') && canBulkComplete" :loading="completing" :disabled="checkedOrderIds.length == 0" @click="complete">
                            COMPLETE
                        </b-button>
                        <b-button v-if="isFilterStatus('COMPLETED')" :loading="claiming" :disabled="checkedOrderIds.length == 0" @click="claim">
                            CLAIM
                        </b-button>
                        <!--
                        <button :class="`button ${rejecting ? 'is-loading' : ''}`" @click="reject" v-if="isFilterStatusBLRQ && checkedOrderIds.length">
                            REJECT
                        </button>
                        -->
                        <button v-if="canBulkBlap" :class="`button ${approving ? 'is-loading' : ''}`" @click="approve">
                            APPROVE
                        </button>
                        <b-button v-if="checkedOrderIds.length" :loading="cancelling" @click="cancel">
                            CANCEL
                        </b-button>
                        <b-button :loading="exportLoading" :disabled="exportLoading" @click="onExport">
                            EXPORT
                        </b-button>
                        <button id="order-create" class="button is-light" @click="$router.replace({ name: 'order-create' })" :disabled="!canIssueOrders">
                            <span class="icon"><i class="fa fa-plus-square fa-lg"></i></span>
                        </button>
                        <button type="button" class="button is-light" @click.prevent="mode = 'calendar'">
                            <span class="icon"><i class="fa fa-calendar fa-lg"></i></span>
                        </button>
                        <b-button id="orders_filter" name="orders_filter" :type="`${hasActiveFilters ? 'is-warning' : 'is-light'}`" @click="mode = 'filter'">
                            <span class="icon"><i class="fa fa-filter fa-lg"></i></span>
                        </b-button>
                        <b-field>
                            <b-radio-button v-model="orderSource" title="INBOUND" native-value="inbound" type="is-info">
                                <span class="icon" title="ORDERS RECEIVED" style="margin: 0"><i class="fa fa-inbox fa-lg"></i></span>
                            </b-radio-button>
                            <b-radio-button v-model="orderSource" title="OUTBOUND" native-value="outbound" type="is-info">
                                <span class="icon" title="ORDERS ISSUED" style="margin: 0"><i class="fa fa-paper-plane fa-lg"></i></span>
                            </b-radio-button>
                        </b-field>
                    </template>
                </orders-table>
                <orders-calendar
                    v-show="mode === 'calendar'"
                    :filters="fetchParams"
                    :order="selectedOrder"
                    :show-date="filters.requiredFinishEnd"
                    @click-item="(order) => (selectedOrder = order)"
                    @generate-items="onCalendarGenerateItems"
                    ref="calendar"
                >
                    <template #headerButtons>
                        <button type="button" class="button is-light" @click.prevent="mode = 'list'">
                            <span class="icon"><i class="fa fa-list fa-lg"></i></span>
                        </button>
                        <b-button id="orders_filter" name="orders_filter" :type="`${hasActiveFilters ? 'is-warning' : 'is-light'}`" @click="mode = 'filter'">
                            <span class="icon"><i class="fa fa-filter fa-lg"></i></span>
                        </b-button>
                    </template>
                </orders-calendar>
                <filters
                    v-show="mode === 'filter'"
                    :filters="filters"
                    @filter="onFilter"
                    @reset="onFilterReset"
                    @select-issued-to="onFilterSelectIssuedTo"
                    ref="filters"
                    :billingCode="code"
                    :assetCode="asset"
                    :managersId="managers"
                >
                    <template #headerButtons>
                        <button type="button" class="button is-light" @click.prevent="mode = 'calendar'">
                            <span class="icon"><i class="fa fa-calendar fa-lg"></i></span>
                        </button>
                        <button type="button" class="button is-light" @click.prevent="mode = 'list'">
                            <span class="icon"><i class="fa fa-list fa-lg"></i></span>
                        </button>
                    </template>
                </filters>
            </div>
            <div id="split-2" class="column is-6" style="margin: 0; padding: 0">
                <detail
                    v-if="selectedOrder"
                    :order="selectedOrder"
                    @close="unSelect"
                    @fetched-relationships="onDetailFetchedRelationships"
                    @cancel="onDetailCancel"
                    @approve-billing="onDetailApproveBilling"
                >
                </detail>
                <dashboard
                    v-show="!selectedOrder"
                    :filters="filters"
                    :fetch-params="fetchParams"
                    @filter="onDashboardFilter"
                    @reset="onDashboardReset"
                    ref="dashboard"
                >
                    <template #headerButtons>
                        <button class="button is-light">CREATE</button>
                        <button class="button is-light">FILTER</button>
                    </template>
                </dashboard>
            </div>
        </div>
    </div>
</template>

<script>

    import Split from "split.js";
    import Filters from "@/components/OrderFilter/OrderFilter";
    import OrdersTable from "../partials/table";
    import OrdersCalendar from "../partials/calendar";
    import Detail from "../partials/detail";
    import Dashboard from "../partials/dashboard";
    import BaseSelect from "@/components/partials/BaseSelect";
    import ClaimLineImporter from "@/components/ClaimLine/ClaimLineImporter";
    import { ordersListPageMixin } from "../mixins/ordersListPageMixin";
    import { UserService } from "@/services/user.service";

    export default {
        components: {
            Filters,
            OrdersTable,
            Detail,
            Dashboard,
            BaseSelect,
            OrdersCalendar,
            ClaimLineImporter,
        },
        mixins: [ordersListPageMixin],
        data: () => ({
            claimLinesImporter: {
                active: false,
            },
            splitSizes: [50, 50],
        }),
        mounted() {
            if (this.$store.getters["Auth/hasPermission"]("resizable orders page")) {
                this.splitSizes = this.$store.getters["Auth/orderSplitPreference"]
                    .split(",")
                    .map((v) => parseFloat(v));
                Split(["#split-1", "#split-2"], {
                    sizes: this.splitSizes,
                    gutterStyle: () => ({
                        width: "5px",
                        "background-color": "#ccc",
                    }),
                    onDragEnd: (sizes) => {
                        UserService.updateAttribute(this.$store.state.Auth.user.id, {
                            code: "order_split_preference",
                            value: sizes.join(","),
                        });
                        this.$refs.dashboard.loadChart();
                        this.splitSizes = sizes;
                    },
                });
            }
        },
    };

</script>

<style lang="scss">

    .orders {

        height: calc(100vh - 50px);

        // @media only screen and (min-width: 769px) {
        //   .filters {
        //     .scrollable {
        //       height: calc(100vh - 7rem - 4rem);
        //     }
        //   }
        //   .order-table {
        //     .card-content {
        //       height: calc(100vh - 7rem);
        //     }
        //   }
        //   .detail {
        //     .scrollable {
        //       height: calc(100vh - 7rem);
        //     }
        //   }
        //   .dashboard {
        //     .scrollable {
        //       height: calc(100vh - 7rem);
        //     }
        //   }
        // }

        .filters {
            height: 100%;
        }

        .filters>.card {
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .filters>.card-content {
            flex-grow: 1;
        }

        .order-table {
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .order-table>.card-content {
            flex-grow: 1;
        }

        .card.detail {
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .card.detail>.card-content {
            flex-grow: 1;
        }

        .dashboard {
            height: 100%;
            display: flex;
            flex-direction: column;
        }

        .dashboard>.card-content {
            flex-grow: 1;
        }

        /* Cursor is not showing initially */
        .gutter {
            cursor: col-resize;
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/pages/Orders/list-new/layouts/default.vue